import { inject, Injectable } from '@angular/core';
import { map, repeat, switchMap } from 'rxjs/operators';
import { ConfigService } from '@app/services';
import { PageSchema } from '@app/schemas/page';
import { of, shareReplay } from 'rxjs';
import { AvailabilityService } from '@app/services/availability';

@Injectable({
  providedIn: 'root',
})
export class PageService {

  private readonly availabilityService = inject(AvailabilityService);
  private readonly configService = inject(ConfigService);

  public readonly config$ = this.configService.config$.pipe(
    switchMap(({ pages }) => of(pages).pipe(
      repeat({
        delay: () => this.availabilityService.buildSchedule$(
          pages.map(page => page.availability),
        ),
      }),
      map((pages) => {
        return this.filterAvailablePages(pages);
      }),
    )),
    shareReplay(1),
  );

  public findPageById(pages: PageSchema[], pageId: string): PageSchema | undefined {
    return pages.find(page => page.id === pageId);
  }

  public filterAvailablePages(pages: PageSchema[]): PageSchema[] {
    return pages.filter(({ availability }) => {
      return this.availabilityService.checkAvailability(availability);
    });
  }

}
